import { render, staticRenderFns } from "./IconoRetirado.vue?vue&type=template&id=d31abaae&"
import script from "./IconoRetirado.vue?vue&type=script&lang=js&"
export * from "./IconoRetirado.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports